export default __webpack_public_path__ + "static/media/Pot2.4c202bd9.svg";